import { TableSection } from 'components/common/TableSection';
import { Container } from 'components/layout/Container';
import { MembershipsList } from 'components/Memberships/MembershipsList/MembershipsList';
import { RolandPlan } from 'components/RolandPlan/RolandPlan';

export const Memberships = () => (
  <>
    <Container>
      <MembershipsList />
      <RolandPlan />
      <TableSection />
    </Container>
  </>
);
